(() => {
  'use strict';
  const labels = JSON.parse(document.getElementById('NzcFinishLabels')?.textContent || '{}');
  const dialog = document.getElementById('NzcContactDialog');
  let contactTrigger;
  const selectedVariant = () => {
    try {
      const variants = JSON.parse(document.getElementById('nzc-variants')?.textContent || '[]');
      return variants.find(v => String(v.id) === document.getElementById('nzc-variant')?.value);
    } catch (_) { return undefined; }
  };
  const openContact = trigger => {
    if (!dialog) return;
    contactTrigger = trigger;
    const variant = selectedVariant();
    let message = labels.general_message || '';
    if (dialog.dataset.productTitle) {
      const productUrl = new URL(dialog.dataset.productUrl, location.origin);
      if (variant) productUrl.searchParams.set('variant', variant.id);
      message = (labels.product_message || '').replace('__title__', dialog.dataset.productTitle)
        .replace('__option__', variant?.title || '').replace('__url__', productUrl.href);
    }
    const whatsapp = dialog.querySelector('[data-nzc-whatsapp]');
    if (whatsapp) whatsapp.href = 'https://wa.me/' + whatsapp.dataset.number.replace(/[^0-9]/g, '') + '?text=' + encodeURIComponent(message);
    try {
      if (whatsapp) window.NzcAttribution?.prepare(whatsapp, {
        url: dialog.dataset.productUrl || location.href,
        variant: variant?.id ? String(variant.id) : null,
        channel:'whatsapp',entryPoint:trigger.closest('header')?'header-help':trigger.closest('footer')?'footer-help':dialog.dataset.productTitle?'product-help':'page-help'
      });
    } catch (_) {}
    dialog.querySelector('[data-nzc-email]').href = 'mailto:info@indiancricketstore.com?subject='
      + encodeURIComponent(labels.email_subject || '') + '&body=' + encodeURIComponent(message);
    try {window.NzcAttribution?.prepare(dialog.querySelector('[data-nzc-email]'),{url:dialog.dataset.productUrl||location.href,variant:variant?.id?String(variant.id):null,channel:'email',entryPoint:dialog.dataset.productTitle?'product-help':'page-help'});} catch (_) {}
    if (!dialog.open) dialog.showModal();
  };
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-nzc-contact-close]');
    if (close) { dialog?.close(); return; }
    const link = event.target.closest('a,button[data-nzc-contact]');
    if (!link || link.closest('#NzcContactDialog')) return;
    const href = link.getAttribute('href') || '';
    const text = link.textContent.trim().toLowerCase();
    let contactPage = false;
    try { const url = new URL(href, location.href); contactPage = url.origin === location.origin && url.pathname.replace(/\/$/, '') === '/pages/contact-us' && !url.searchParams.has('view'); } catch (_) {}
    const contactLink = link.hasAttribute('data-nzc-contact')
      || /^mailto:info@indiancricketstore\.com(?:[?]|$)/i.test(href)
      || contactPage
      || /help me choose|ask (?:an )?expert|expert advice|ask us/.test(text);
    if (!contactLink || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openContact(link);
  });
  dialog?.addEventListener('close', () => contactTrigger?.focus());
  document.querySelectorAll('[data-brand-directory]').forEach(directory => {
    const input = directory.querySelector('[data-brand-search]');
    const cards = Array.from(directory.querySelectorAll('[data-brand-card]'));
    const count = directory.querySelector('[data-brand-count]');
    const empty = directory.querySelector('[data-brand-empty]');
    input?.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach(card => { card.hidden = !card.dataset.brandName.includes(query); if (!card.hidden) visible++; });
      count.textContent = (labels.brand_count || '__count__').replace('__count__', visible);
      empty.hidden = visible > 0;
    });
  });
  const payment = document.querySelector('[data-payment-summary]');
  const form = document.getElementById('nzc-product-form');
  const refreshPayments = () => {
    if (!payment || !form) return;
    const variant = selectedVariant();
    if (!variant) return;
    const quantity = Math.max(1, Number(form.querySelector('[name=quantity]')?.value) || 1);
    let total = variant.price * quantity;
    const service = form.querySelector('[data-service]');
    if (service?.value) total += (Number(service.selectedOptions[0].dataset.price) || 0) * quantity;
    form.querySelectorAll('[data-addon]:checked').forEach(addon => total += (Number(addon.dataset.price) || 0) * quantity);
    total = Math.round(total);
    const available = payment.dataset.currency === 'INR'
      && total >= Number(payment.dataset.afterpayMin) && total <= Number(payment.dataset.afterpayMax);
    const plan = payment.querySelector('[data-afterpay-plan]');
    const unavailable = payment.querySelector('[data-afterpay-unavailable]');
    if (plan) plan.hidden = !available;
    if (unavailable) unavailable.hidden = available;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency:payment.dataset.currency || 'INR'});
    const base = Math.floor(total / 4), remainder = total % 4;
    payment.querySelectorAll('[data-afterpay-part]').forEach((part,index) => {
      part.textContent = formatter.format((base + (index < remainder ? 1 : 0)) / 100);
    });
  };
  form?.addEventListener('change', refreshPayments);
  form?.addEventListener('input', refreshPayments);
  document.addEventListener('variant:change', refreshPayments);
  refreshPayments();
  const stickyBars = Array.from(document.querySelectorAll('[data-product-sticky],[data-cart-sticky]'));
  if (stickyBars.length) {
    let placementFrame;
    const syncStickyPlacement = () => {
      placementFrame = undefined;
      let clearance = 0;
      stickyBars.forEach(bar => {
        const visible = bar.classList.contains('visible');
        bar.inert = !visible;
        bar.setAttribute('aria-hidden', String(!visible));
        if (visible) clearance = Math.max(clearance, Math.ceil(bar.getBoundingClientRect().height) + 12);
      });
      document.documentElement.style.setProperty('--nzc-sticky-clearance', clearance + 'px');
    };
    const schedulePlacement = () => {
      if (placementFrame === undefined) placementFrame = requestAnimationFrame(syncStickyPlacement);
    };
    const stickyObserver = new MutationObserver(schedulePlacement);
    const stickyResize = new ResizeObserver(schedulePlacement);
    stickyBars.forEach(bar => {
      stickyObserver.observe(bar, {attributes: true, attributeFilter: ['class']});
      stickyResize.observe(bar);
    });
    schedulePlacement();
  }
  document.querySelectorAll('a[href="#nzc-product-delivery"]').forEach(link => {
    link.addEventListener('click', () => {
      const disclosure = document.querySelector('#nzc-product-delivery .nzc-delivery-disclosure');
      if (disclosure) disclosure.open = true;
    });
  });
  document.querySelectorAll('[data-quote-builder]').forEach(builder => {
    const contactForm = builder.closest('form');
    contactForm?.addEventListener('submit', event => {
      const selected = builder.querySelector('[data-quote-field]');
      if (!selected?.value.trim()) {
        event.preventDefault();
        let error = builder.querySelector('[data-quote-validation]');
        if (!error) {
          error = document.createElement('p'); error.dataset.quoteValidation = '';
          error.setAttribute('role','alert'); error.setAttribute('tabindex','-1');
          error.className = 'nzc-quote-validation'; builder.append(error);
        }
        error.textContent = labels.quote_empty_error || ''; error.focus();
      }
    });
  });
})();

